import { LastYearWeeklyTrend } from '../../pages/CropTrends/CropTrendsListPage/components/CropPriceSummaryCard';
import { customAxios } from '../common/customAxios';

interface IWholesaleMarket {
  wholesaleMarketName: string;
  wholesaleMarketCode: string;
  todayAveragePrice: number;
  dailyChange: {
    previousPrice: number;
    changeAmount: number;
    changeRate: number;
  };
  lastYearWeeklyTrend: LastYearWeeklyTrend;
}

export interface IFavoriteCropPrice {
  largeCategoryCode: string;
  middleCategoryCode: string;
  smallCategoryCode: string;
  smallCategoryName: string;
  wholesaleMarket: IWholesaleMarket[];
}

export const getCropFavoritePrices = (): Promise<IFavoriteCropPrice[]> => {
  return customAxios.get('/crops/favorite-prices');
};
